<template>
  <div
    class="section-parent-checks"
    qa="section-parent-checks-container"
  >
    <div class="section-header p-1 text-center main">
      <b-col>{{ $t('diagnosis.sidebar.groups') }}</b-col>
    </div>
    <div
      id="priorities"
      class="group"
      qa="section-parent-check-group"
    >
      <div
        class="check-parent d-flex align-items-center justify-content-center py-2 px-2"
        qa="section-parent-check-header"
      >
        <div class="px-2">
          <i
            class="fal fa-flag white"
            aria-hidden="true"
          />
        </div>
        <div
          class="title d-flex justify-content-between align-items-center"
          qa="priorities"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.priorities') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'priorities'"
        placement="rightbottom"
        :container="'priorities'"
        class="popover-sections"
      >
        <div class="menu-popover ap-sidebar--compact__pop pop-module check-popover">
          <div
            class="menu-popover-title d-flex align-items-center"
            style="padding: 0 15px"
          >
            <b-form-checkbox
              v-model="parentCheckboxesState.allPrioritiesSelected"
              :indeterminate="parentCheckboxesState.prioritiesIndeterminate"
              @change="selectAll($event, priorities, priorityChangeHandler)"
            />
            <div>{{ $t('diagnosis.sidebar.checkBox.priorities') }}</div>
          </div>
          <ul class="section-list px-0 m-0">
            <li
              v-for="(option, index) in priorities"
              :key="index"
              class="py-2"
            >
              <b-form-checkbox
                v-model="option.checked"
                @change="priorityChangeHandler"
              >
                <span>{{ option.name }}</span>
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </b-popover>
    </div>
    <div
      id="caseTypes"
      class="group"
    >
      <div class="check-parent d-flex align-items-center justify-content-center py-2 px-2">
        <div class="px-2">
          <i
            class="fal fa-chart-network white"
            aria-hidden="true"
          />
        </div>
        <div
          class="title d-flex justify-content-between align-items-center"
          qa="caseTypes"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.caseTypes') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'caseTypes'"
        placement="rightbottom"
        :container="'caseTypes'"
        class="popover-sections"
      >
        <div class="menu-popover ap-sidebar--compact__pop pop-module check-popover">
          <div
            class="menu-popover-title d-flex align-items-center"
            style="padding: 0 15px"
          >
            <b-form-checkbox
              v-model="parentCheckboxesState.allCaseTypesSelected"
              :indeterminate="parentCheckboxesState.caseTypesIndeterminate"
              @change="selectAll($event, caseTypes, caseTypeChangeHandler)"
            />
            <div>{{ $t('diagnosis.sidebar.checkBox.caseTypes') }}</div>
          </div>
          <ul class="section-list px-0 m-0">
            <li
              v-for="(option, index) in caseTypes"
              :key="index"
              class="py-2"
            >
              <b-form-checkbox
                v-model="option.checked"
                @change="caseTypeChangeHandler"
              >
                <span>{{ option.description }}</span>
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </b-popover>
    </div>
    <div
      id="sampleTypes"
      class="group"
    >
      <div class="check-parent d-flex align-items-center justify-content-center py-2 px-2">
        <div class="px-2">
          <i
            class="fal fa-prescription-bottle white"
            aria-hidden="true"
          />
        </div>
        <div
          class="title d-flex justify-content-between align-items-center"
          qa="sampleTypes"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.sampleTypes') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'sampleTypes'"
        placement="rightbottom"
        :container="'sampleTypes'"
        class="popover-sections"
      >
        <div class="menu-popover ap-sidebar--compact__pop pop-module check-popover">
          <div
            class="menu-popover-title d-flex align-items-center"
            style="padding: 0 15px"
          >
            <b-form-checkbox
              v-model="parentCheckboxesState.allSampleTypesSelected"
              :indeterminate="parentCheckboxesState.sampleTypesIndeterminate"
              @change="selectAll($event, sampleTypes, sampleTypeChangeHandler)"
            />
            <div>{{ $t('diagnosis.sidebar.checkBox.sampleTypes') }}</div>
          </div>
          <ul class="section-list px-0 m-0">
            <li
              v-for="(option, index) in sampleTypes"
              :key="index"
              class="py-2"
            >
              <b-form-checkbox
                v-model="option.checked"
                @change="sampleTypeChangeHandler"
              >
                <span>{{ option.description }}</span>
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </b-popover>
    </div>
    <div
      id="laboratories"
      class="group"
    >
      <div class="check-parent d-flex align-items-center justify-content-center py-2 px-2">
        <div class="px-2">
          <i
            class="fal fa-hospital white"
            aria-hidden="true"
          />
        </div>
        <div
          class="title d-flex justify-content-between align-items-center"
          qa="laboratories"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.laboratories') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            style="font-size:0.7rem;color: #707070"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'laboratories'"
        placement="rightbottom"
        :container="'laboratories'"
        class="popover-sections"
      >
        <div class="menu-popover ap-sidebar--compact__pop pop-module check-popover">
          <div
            class="menu-popover-title d-flex align-items-center"
            style="padding: 0 15px"
          >
            <b-form-checkbox
              v-model="parentCheckboxesState.allLaboratoriesSelected"
              :indeterminate="parentCheckboxesState.laboratoriesIndeterminate"
              @change="selectAll($event, laboratories, laboratoriesChangeHandler)"
            />
            <div>{{ $t('diagnosis.sidebar.checkBox.laboratories') }}</div>
          </div>
          <ul class="section-list px-0 m-0">
            <li
              v-for="(option, index) in laboratories"
              :key="index"
              class="py-2"
            >
              <b-form-checkbox
                v-model="option.checked"
                @change="laboratoriesChangeHandler"
              >
                <span>{{ option.labName }}</span>
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<script>
import diagnosisChecksMixin from '@/modules/diagnosisModule/sideBar/diagnosisSidebarChecks/diagnosisChecksMixin'
export default {
    name: 'SectionParentChecksCompact',
    mixins: [diagnosisChecksMixin]
}
</script>

<style lang="scss" scoped>
.section-list {
  max-height: calc(60vh - 10px);
  overflow-y: auto;
}

.section-list {
  background: vt-color(sidebar-childs-bg);
  color: vt-color(white-light);
}

.section-list li:hover {
  background: vt-color(primary);
}

.section-parent-checks {
  display: none;
}

.option-nav:hover .option-nav-lock {
  visibility: visible;
}

.option-nav {
  transition: 1s;
  list-style: none;
}

.option-nav:hover {
  transition: 0.5s;
  background: vt-color(primary);
}

.check-parent {
  transition: 0.3s;
  cursor: pointer;
}

.check-parent:hover {
  background-color: vt-color(primary);
}

.check-parent .title {
  width: 100%;
}

.check-parent .title span {
  font-size: font-size(very-small);
  color: #707070;
  margin-left: 4px;
}

.sub-menu-items {
  background: vt-color(sidebar-childs-bg);
  transition: 0.3s;
  border-bottom: 0.3px solid #f0f0f0 !important;
}

.sub-menu-items:hover {
  background: vt-color(primary);
}

.sub-menu-items li {
  list-style: none;
}

.sub-menu-items p {
  font-size: font-size(very-small);
  color: #707070;
  margin-left: 12px;
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  cursor: pointer;
}

.section-header {
  height:10px;
  width: 100%;
  background: vt-color(sidebar-section-header-bg);
}

.menu-popover li {
  list-style: none;
  width: 200px;
  padding: 0 15px;
}

.menu-popover-title {
  margin-bottom: 0;
  padding-left: 1.3rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

</style>
